const ACTION_TYPES = {
  MODAL: 'MODAL',
  LINK: 'LINK',
};

export { ACTION_TYPES };
